export default __webpack_public_path__ + "static/agency-688f83dba91638723f8d5f209ec9ebd2.svg";